import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { PickListModule } from 'primeng/picklist';
import { TableModule } from 'primeng/table';
import { RippleModule } from 'primeng/ripple';
import { CalendarModule } from 'primeng/calendar';
import { PasswordModule } from 'primeng/password';
import { InputMaskModule } from 'primeng/inputmask';
import { CheckboxModule } from 'primeng/checkbox';

// Services
import { GenericFormService } from './form-field/service/generic-form.service';
import { FormModelService } from './form-field/service/form-model.service';

// Components
import { SelectButtonFieldComponent } from './form-field/select-button-field/select-button-field.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormInputFieldComponent } from './form-field/input-field/input-field.component';
import { DropdownFieldComponent } from './form-field/dropdown-field/dropdown-field.component';
import { InputSwitchFieldComponent } from './form-field/input-switch-field/input-switch-field.component';
import { SliderFieldComponent } from './form-field/slider-field/slider-field.component';
import { RadioButtonFieldComponent } from './form-field/radio-button-field/radio-button-field.component';
import { SelectChipsComponent } from './form-field/select-chips/select-chips.component';
import { PicklistFieldComponent } from './form-field/picklist-field/picklist-field.component';
import { TableFieldComponent } from './form-field/table-field/table-field.component';
import { ModalTableFieldComponent } from './form-field/modal-table-field/modal-table-field.component';
import { TableDataConfigurationComponent } from './form-field/modal-table-field/table-data-configuration/table-data-configuration.component';
import { CreateEditFieldValueComponent } from './form-field/components/create-edit-field-value/create-edit-field-value.component';
import { CalendarFieldComponent } from './form-field/calendar-field/calendar-field.component';
import { ArrayFieldComponent } from './form-field/array-field/array-field.component';
import { RowArrayComponent } from './form-field/array-field/components/row-array/row-array.component';
import { TableArrayComponent } from './form-field/array-field/components/table-array/table-array.component';
import { PasswordFieldComponent } from './form-field/password-field/password-field.component';
import { CheckboxFieldComponent } from './form-field/checkbox-field/checkbox-field.component';
import { ArrayCheckboxFieldComponent } from './form-field/array-checkbox-field/array-checkbox-field.component';
import { DropdownFieldV2Component } from './form-field/dropdown-field-v2/dropdown-field-v2.component';

const COMPONENTS = [
  FormFieldComponent,
  FormInputFieldComponent,
  DropdownFieldComponent,
  DropdownFieldV2Component,
  SelectButtonFieldComponent,
  InputSwitchFieldComponent,
  SliderFieldComponent,
  RadioButtonFieldComponent,
  SelectChipsComponent,
  PicklistFieldComponent,
  TableFieldComponent,
  ModalTableFieldComponent,
  TableDataConfigurationComponent,
  CreateEditFieldValueComponent,
  CalendarFieldComponent,
  ArrayFieldComponent,
  CheckboxFieldComponent,
  ArrayCheckboxFieldComponent
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    AutoCompleteModule,
    InputSwitchModule,
    MultiSelectModule,
    SelectButtonModule,
    SliderModule,
    InputTextModule,
    InputNumberModule,
    FormsModule,
    RadioButtonModule,
    ButtonModule,
    ChipModule,
    PickListModule,
    TableModule,
    RippleModule,
    CalendarModule,
    PasswordModule,
    InputMaskModule,
    CheckboxModule
  ],
  declarations: [
    ...COMPONENTS,
    RowArrayComponent,
    TableArrayComponent,
    PasswordFieldComponent,
  ],
  exports: [...COMPONENTS],
  providers: [GenericFormService, FormModelService],
})
export class GenericFormModule {}
